import {
 ACCESS_TOKEN_KEY,
 REFRESH_TOKEN_KEY,
} from 'constants/common'
import ApiResponse from 'models/ApiResponse'
import {post} from 'utils/axios'
import {getCookieValue, persistToken} from 'utils/helper'

interface RefreshTokenAuth {
 accessToken?: string
 refreshToken?: string
 accessExpiresIn?: number
 refreshExpiresIn?: number
}

interface RefreshTokenData {
 auth?: RefreshTokenAuth
}

export interface RefreshTokensResult {
 accessToken: string
 refreshToken: string
 accessExpiresIn?: number
 refreshExpiresIn?: number
}

export async function refreshTokens(
 refreshToken?: string | null
): Promise<RefreshTokensResult | null> {
 const token =
  refreshToken ?? getCookieValue(REFRESH_TOKEN_KEY)
 if (!token) {
  return null
 }

 try {
  const response = await post<
   ApiResponse<RefreshTokenData>
  >('/v1/refresh-token', {refreshToken: token})

  const user = response.data
  if (
   user.status === 'Success' &&
   user.data?.auth?.accessToken &&
   user.data?.auth?.refreshToken
  ) {
   const {auth} = user.data
   persistToken(
    ACCESS_TOKEN_KEY,
    auth.accessToken,
    auth.accessExpiresIn
   )
   persistToken(
    REFRESH_TOKEN_KEY,
    auth.refreshToken,
    auth.refreshExpiresIn
   )
   return {
    accessToken: auth.accessToken,
    refreshToken: auth.refreshToken,
    accessExpiresIn: auth.accessExpiresIn,
    refreshExpiresIn: auth.refreshExpiresIn,
   }
  }
  return null
 } catch {
  return null
 }
}
